const IconFacebook = (props) => {
    return (
      <svg className={props.className} width="54" height="54" viewBox="0 0 54 54" fill="none" stroke="#4d738b" xmlns="http://www.w3.org/2000/svg">
        <g id="Group_521" data-name="Group 521" transform="translate(-398 -606)">

          <path id="Icon_feather-facebook" data-name="Icon feather-facebook" d="M27,3H22.5A7.5,7.5,0,0,0,15,10.5V15H10.5v6H15V33h6V21h4.5L27,15H21V10.5A1.5,1.5,0,0,1,22.5,9H27Z" transform="translate(406 615.5)" fill="none" stroke="#4d738b" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
      </svg>
    )
}

export default IconFacebook;